<template>
  <div class="page-container">
    <div class="header">
      <h1>Welcome</h1>
    </div>

    <div class="content">
      <r-button @click="$router.push('/chat')">Go To Chat</r-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MissionControl',
  props: {

  }
}
</script>

<style scoped>

h1 {
  text-align: center;
}

</style>
